export default "__VITE_ASSET__CmaubEww__"